/**
 * Tenant-aware entity labels for the Returns surfaces.
 *
 * A return is always scoped to a customer, so the customer / site-group /
 * site labels on every return form and the summary must use that customer's
 * vocabulary (billboard customers see "Plant" / "Structure", commercial
 * customers see "Site Group" / "Site"). One resolver keeps all four forms
 * and the read-only summary speaking the same language.
 *
 * Contains:
 * - returnEntityLabels — resolve { customer, siteGroup, structure } labels
 */

/** Read is_billboard from either an Immutable Map or a plain object. */
function readIsBillboard(customer) {
  if (!customer) return true;
  const value = customer.get ? customer.get('is_billboard', true) : customer.is_billboard;
  return value ?? true;
}

/**
 * Resolve the customer / site-group / site labels for a return's customer.
 *
 * @param {Function} t - i18next translate
 * @param {import('immutable').Map|Object|null} customer - the RMA's customer
 * @returns {{ customer: string, siteGroup: string, structure: string }}
 */
export function returnEntityLabels(t, customer) {
  const isBillboard = readIsBillboard(customer);
  return {
    customer: t('general.customer', 'Customer'),
    siteGroup: isBillboard ? t('general.plant', 'Plant') : t('general.siteGroup', 'Site Group'),
    structure: isBillboard ? t('general.structure', 'Structure') : t('general.site', 'Site'),
  };
}
